import React from "react";
import { Flex, Tab, Tabs } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";
import type { TabConfig } from "./types";

type WorkflowTabsProps = {
  tabs: TabConfig[];
  activeTabKey: string;
  onTabChange: (tabKey: string) => void;
  rightContent?: React.ReactNode;
};

export const WorkflowTabs: React.FC<WorkflowTabsProps> = ({
  tabs,
  activeTabKey,
  onTabChange,
  rightContent,
}) => {
  const visibleTabs = tabs.filter((tab) => tab.visible);

  return (
    <Flex
      className={styles.tabsContainer}
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Tabs hasBottomBorder={false} tabsListClassName={styles.tabsList}>
        {visibleTabs.map((tab) => (
          <Tab
            key={tab.key}
            text={tab.label}
            active={tab.key === activeTabKey}
            data-testid={tab.testId}
            className={tab.key === activeTabKey ? styles.tabActive : styles.tabInactive}
            onClick={() => onTabChange(tab.key)}
          />
        ))}
      </Tabs>
      {rightContent}
    </Flex>
  );
};
